export const getInitialValues = (lawyer, isSelfRepresented) => {
  if (lawyer?._id) {
    return {
      name: lawyer?.name || "",
      orgName: lawyer?.orgName || "",
      sanityId: lawyer?.sanityId || lawyer?._id || "non-sanity",
      isSelfRepresented: typeof isSelfRepresented === "boolean" ? !!isSelfRepresented : false,
      location: {
        phone: lawyer?.phone || "",
        postal: lawyer?.postal || "",
        country: lawyer?.country || "",
        residence: lawyer?.residence?.shorthand || lawyer?.residence || null,
        street1: lawyer?.street1 || "",
        street2: lawyer?.street2 || "",
        city: lawyer?.city || "",
        email: lawyer?.email || "",
        fax: lawyer?.fax || "",
      },
    };
  }

  return {
    name: lawyer?.name || "",
    orgName: lawyer?.orgName || "",
    sanityId: lawyer?.sanityId || "non-sanity",
    isSelfRepresented: typeof isSelfRepresented === "boolean" ? !!isSelfRepresented : false,
    location: {
      phone: lawyer?.location?.phone || "",
      postal: lawyer?.location?.postal || "",
      country: lawyer?.location?.country || "",
      residence: lawyer?.location?.residence || null,
      street1: lawyer?.location?.street1 || "",
      street2: lawyer?.location?.street2 || "",
      city: lawyer?.location?.city || "",
      email: lawyer?.location?.email || "",
      fax: lawyer?.location?.fax || "",
    },
  };
};
